export type SortColumn = string | null;

// A column can either be sorted ascending, descending, or unsorted.
export type SortDirection = 'asc' | 'desc' | 'none';

// Stores a column and a direction pair to be used when sorting list views
export type Sort = {
  column: SortColumn;
  direction: SortDirection;
};

export const SORT_EMPTY: Sort = { column: null, direction: 'none' };
